import { useTranslation } from "react-i18next";
import StatGrid from "@/components/common/StatGrid";
import { formatLapTime } from "@/utils/timeFormat";
import type { TeamStats } from "@/types";

export default function TeamStatsSection({ stats }: { stats: TeamStats }) {
  const { t, i18n } = useTranslation("pages");

  return (
    <div className="space-y-4">
      <StatGrid
        items={[
          { label: t("teams.stats.sessions"), value: stats.totalSessions },
          {
            label: t("teams.stats.laps"),
            value: stats.totalLaps.toLocaleString(i18n.language),
          },
          {
            label: t("teams.stats.bestLap"),
            value:
              stats.bestLapTime != null
                ? formatLapTime(stats.bestLapTime)
                : "—",
            subtext: stats.favoriteTrack
              ? t("teams.stats.atTrack", { track: stats.favoriteTrack.name })
              : undefined,
          },
          { label: t("teams.stats.events"), value: stats.eventsAttended },
        ]}
      />

      <div className="grid grid-cols-1 gap-3 sm:gap-6 lg:grid-cols-2">
        <div className="bg-white p-4 sm:p-6 rounded-lg border border-secondary-200">
          <h3 className="text-xs sm:text-sm font-medium text-secondary-500 uppercase tracking-wide">
            {t("teams.stats.homeTrack")}
          </h3>
          {stats.favoriteTrack ? (
            <div className="mt-2 min-w-0">
              <p className="text-lg sm:text-xl font-bold text-secondary-900 truncate">
                {stats.favoriteTrack.name}
              </p>
              <p className="text-sm text-secondary-600">
                {t("teams.stats.sessions", {
                  count: stats.favoriteTrack.sessionCount,
                })}
              </p>
            </div>
          ) : (
            <p className="text-lg sm:text-xl font-bold text-secondary-900 mt-2">
              {t("teams.stats.na")}
            </p>
          )}
        </div>

        <div className="bg-white p-4 sm:p-6 rounded-lg border border-secondary-200">
          <h3 className="text-xs sm:text-sm font-medium text-secondary-500 uppercase tracking-wide">
            {t("teams.stats.mostUsedCar")}
          </h3>
          {stats.mostUsedVehicle ? (
            <div className="mt-2 min-w-0">
              <p className="text-lg sm:text-xl font-bold text-secondary-900 truncate">
                {stats.mostUsedVehicle.name}
              </p>
              <p className="text-sm text-secondary-600">
                {t("teams.stats.sessions", {
                  count: stats.mostUsedVehicle.sessionCount,
                })}
              </p>
            </div>
          ) : (
            <p className="text-lg sm:text-xl font-bold text-secondary-900 mt-2">
              {t("teams.stats.na")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
